var map = {
	"./img_1.jpg": 93605,
	"./img_2.jpg": 49512,
	"./img_3.jpg": 14320,
	"./img_4.jpg": 76014,
	"./img_5.jpg": 36636,
	"./img_6.jpg": 61281,
	"./img_7.jpg": 68948,
	"./img_8.jpg": 62675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24543;